import { FormTableFieldBase } from '@tempus/patient-forms-service-shared';

export const findFieldConfig = (
  fieldName: string,
  patientFormsServiceBaseFields: FormTableFieldBase[],
): FormTableFieldBase => {
  const ret = patientFormsServiceBaseFields.find((f) => f.name === fieldName);
  if (!ret) {
    throw new Error(`Could not find field config for field name: ${fieldName}`);
  }
  return ret;
};
